import {
  Box,
  Modal,
  Typography,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField
} from '@mui/material';
import ModalContent from '../../../common/components/Modal';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { AssetApi, AssetCategoryDto, CreateAssetCategoryCommand } from '../../../services/netServices';
import { useQuery } from 'react-query';
import { CustomListItem } from '../../checkList/components/ListItem';
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import { toast } from 'react-toastify';
interface CateModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

export default function CateModal({ open, onClose, onSuccess }: CateModalProps): JSX.Element {
  const { t } = useTranslation() as any;

  const [loading, setLoading] = useState(false);

  // Form state
  const [name, setName] = useState('');
  const [parentId, setParentId] = useState<number | null>(null);

  const { data, refetch } = useQuery(
    ['/Asset/Category'],
    async () => {
      const dataLocalStorage = localStorage.getItem('USER')
      const parsedData = JSON.parse(dataLocalStorage ?? '')
      const token = parsedData?.User?.token
      const { data } = await new AssetApi().assetCategoryGet(token);
      return data.Data
    },
    { enabled: false }
  );
  useEffect(() => {
    if (open) {
      refetch()
    }
  }, [open]);

  const handleSave = async () => {
    try {
      setLoading(true);
      const payload: CreateAssetCategoryCommand = {
        Name: name,
        Description: '',
        Type: '',
        ParentId: parentId ?? null,
      };
      const dataLocalStorage = localStorage.getItem('USER')
      const parsedData = JSON.parse(dataLocalStorage ?? '')
      const token = parsedData?.User?.token
      await new AssetApi().assetCategoryPost(token, payload);
      onSuccess?.();
      onClose();
      toast.success(t("00_02_success_saved"));
    } catch (ex) {
      if(ex?.response?.data.Message === 'Category_is_existed'){
        toast.error(t("34_00_category_is_existed"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box>
        <ModalContent onClose={onClose} title={t('34_00_new_category')} width={600}>
          <Box>
            <CustomListItem
              leftContainerWidth={150}
              text={t('34_00_category_parent')}
              RightComponent={
                <FormControl variant="standard" fullWidth>
                  <Select
                    value={parentId ?? ''}
                    onChange={(e) =>
                      setParentId(e.target.value === '' ? null : Number(e.target.value))
                    }
                    variant="standard"
                    displayEmpty
                    renderValue={(selected) => {
                      const selectedItem = data?.find(
                        (c: AssetCategoryDto) => c.Id === Number(selected)
                      );
                      return (
                        <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
                          <span>{selectedItem?.Name}</span>
                          <IconButton
                            size="small"
                            onMouseDown={(e) => {
                              e.preventDefault();   // ngăn mất focus vào select
                              e.stopPropagation();  // ngăn mở dropdown
                              setParentId(null);    // clear về null
                            }}
                          >
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      );
                    }}
                    
                  >
                    {data && data.filter((c: AssetCategoryDto) => c.ParentId === null).length > 0 ? (
                      data
                        .filter((c: AssetCategoryDto) => c.ParentId === null)
                        .map((c: AssetCategoryDto) => (
                          <MenuItem key={c.Id} value={c.Id}>
                            {c.Name}
                          </MenuItem>
                        ))
                    ) : (
                      <MenuItem disabled>{t('00_06_no_data')}</MenuItem>
                    )}
                  </Select>
                </FormControl>
              }
            />
          </Box>
          <Box mt={4}>
            <CustomListItem
              leftContainerWidth={150}
              text={t('34_00_category_name')}
              RightComponent={
                <TextField
                  variant="standard"
                  fullWidth
                  value={name}
                  onChange={(e) => setName(e.target.value)}

                />
              }
            />
          </Box>

          <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
            <Button onClick={onClose} disabled={loading}>
              {t('00_03_cancel')}
            </Button>
            <Button
              variant="contained"
              disabled={loading || !name}
              onClick={handleSave}
            >
              {t('00_03_save')}
            </Button>
          </Box>
        </ModalContent>
      </Box>
    </Modal>
  );
}
